// extracted by mini-css-extract-plugin
module.exports = {"custom_table":"CustomTable_custom_table__3HRt6","nodata":"CustomTable_nodata__2M1tT"};